import { JAVA_SVC } from "../../../config";
import { apiFetch } from "../../../services/httpClient";
import { localStoragePrefix } from "../../../utils/GeneralFunc";
import { uiActions } from "../ui/ui-slice";
import { addAction } from "./add-slice";

export const fetchUserAdd = () => {
  const userData = JSON.parse(
    localStorage.getItem(`${localStoragePrefix}user`)
  );
  return async (dispatch) => {
    const fetchData = async () => {
      const response = await apiFetch(
        `/address/getAddressByUserId/${userData.id}`
      );
      if (!response.ok) {
        throw new Error("fetching cart data failed!");
      }
      const data = await response.json();

      return data;
    };

    try {
      const addList = await fetchData();
      dispatch(addAction.getAdd(addList));
    } catch (error) {
      // console.log("---ADDRESSES NOT FOUND---");
    }
  };
};
export const addUserAdd = (addData) => {
  return async (dispatch) => {
    dispatch(uiActions.InLoadingState());
    const sendRequest = async () => {
      const response = await apiFetch(`/address`, {
        method: "POST",
        body: JSON.stringify(addData),
       
      });
      if (!response.ok) {
        throw new Error("adding user address data failed!");
      }
    };

    try {
      await sendRequest();

      function setTimeoutPromise(delay) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            dispatch(addAction.addDataChanged());
            resolve(`wait for ${delay} milliseconds `);
            // reject("Error!");
          }, delay);
        });
      }

      setTimeoutPromise(250).then((msg) => {
        console.log(msg);
        dispatch(uiActions.CloseLoadingState());
      });

      console.log("adding user address data successfully!");
    } catch (error) {
      dispatch(uiActions.CloseLoadingState());
      console.log(error);
    }
  };
};
export const updateDefaultUserAdd = (addData) => {
  return async (dispatch) => {
    dispatch(uiActions.InLoadingState());
    const sendRequest = async () => {
      const response = await apiFetch(`/address/updatedefaultaddress`, {
        method: "POST",
        body: JSON.stringify(addData),
      
      });
      if (!response.ok) {
        throw new Error("update default user address data failed!");
      }
    };

    try {
      await sendRequest();

      function setTimeoutPromise(delay) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            dispatch(addAction.addDataChanged());
            resolve(`wait for ${delay} milliseconds `);
            // reject("Error!");
          }, delay);
        });
      }

      setTimeoutPromise(250).then((msg) => {
        console.log(msg);
        dispatch(uiActions.CloseLoadingState());
      });

      console.log("update default user address data successfully!");
    } catch (error) {
      dispatch(uiActions.CloseLoadingState());
      console.log(error);
    }
  };
};
export const deleteUserAdd = (id) => {
  return async (dispatch) => {
    // dispatch(uiActions.InLoadingState());
    const sendRequest = async () => {
      const response = await apiFetch(`/address/${id}`, {
        method: "DELETE",

       
      });
      if (!response.ok) {
        throw new Error("delete user address failed!");
      }
    };

    try {
      await sendRequest();

      function setTimeoutPromise(delay) {
        return new Promise((resolve, reject) => {
          setTimeout(() => {
            dispatch(addAction.addDataChanged());
            resolve(`wait for ${delay} milliseconds `);
            // reject("Error!");
          }, delay);
        });
      }

      setTimeoutPromise(250).then((msg) => {
        console.log(msg);
        dispatch(uiActions.CloseLoadingState());
      });

      console.log("delete user address successfully!");
    } catch (error) {
      // dispatch(uiActions.CloseLoadingState());
      console.log(error);
    }
  };
};
